/* Sold-out size, one email when it is back (after sableau.com; variant A, owner 25 Oct 2026).
   A tap on a sold-out size opens the sheet instead of selecting the size. The email is
   subscribed to Klaviyo's back-in-stock list for the variant of the current colour + that size. */
(() => {
  document.querySelectorAll("[data-bis]").forEach((sheet) => {
    if (sheet.dataset.bound === "1") return;
    sheet.dataset.bound = "1";
    const root = sheet.closest("section");
    if (!root) return;
    let product = null;
    try { product = JSON.parse(root.querySelector("[data-product-json]").textContent); } catch (e) { return; }

    const form = sheet.querySelector("[data-bis-form]");
    const input = form.querySelector('input[type="email"]');
    const button = form.querySelector('button[type="submit"]');
    const title = sheet.querySelector("[data-bis-title]");
    const text = sheet.querySelector("[data-bis-text]");
    const note = sheet.querySelector("[data-bis-note]");
    const noteDefault = note.textContent;
    let variant = null;

    const variantFor = (idx, value) => {
      const opts = [];
      root.querySelectorAll("[data-option-select]").forEach((sel) => {
        opts[parseInt(sel.getAttribute("data-option-index"), 10)] = sel.value;
      });
      opts[idx] = value;
      return product.variants.find((v) => v.options.every((o, i) => o === opts[i]))
        || product.variants.find((v) => !v.available && v.options[idx] === value);
    };

    root.addEventListener("click", (e) => {
      const size = e.target instanceof Element ? e.target.closest("[data-option-size].is-unavailable") : null;
      if (!size) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      variant = variantFor(parseInt(size.getAttribute("data-option-index"), 10), size.getAttribute("data-value"));
      if (!variant) return;
      title.textContent = sheet.dataset.title.replace("%s", size.getAttribute("data-value"));
      text.textContent = sheet.dataset.text.replace("%s", variant.title);
      form.hidden = false;
      note.textContent = noteDefault;
      button.disabled = false;
      sheet.showModal();
    }, true);

    /* A tap on the dimmed backdrop closes the sheet. */
    sheet.addEventListener("click", (e) => { if (e.target === sheet) sheet.close(); });

    form.addEventListener("submit", (e) => {
      e.preventDefault();
      const email = input.value.trim();
      if (!variant || !input.checkValidity() || !email) { note.textContent = sheet.dataset.error; input.focus(); return; }
      button.disabled = true;
      fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=" + encodeURIComponent(sheet.dataset.company), {
        method: "POST",
        headers: { "Content-Type": "application/vnd.api+json", revision: "2025-04-15" },
        body: JSON.stringify({ data: { type: "back-in-stock-subscription", attributes: {
          channels: ["EMAIL"],
          profile: { data: { type: "profile", attributes: { email } } }
        }, relationships: { variant: { data: { type: "catalog-variant", id: "$shopify:::$default:::" + variant.id } } } } })
      }).then((r) => {
        if (!r.ok) throw new Error(String(r.status));
        form.hidden = true;
        note.textContent = sheet.dataset.done.replace("%s", variant.title);
      }).catch(() => {
        button.disabled = false;
        note.textContent = sheet.dataset.error;
      });
    });
  });
})();
